var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHashStraight = function SvgIconHashStraight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 2.75a1 1 0 0 1 1 1V8h4V3.75a1 1 0 1 1 2 0V8h4.25a1 1 0 1 1 0 2H16v4h4.25a1 1 0 1 1 0 2H16v4.25a1 1 0 1 1-2 0V16h-4v4.25a1 1 0 1 1-2 0V16H3.75a1 1 0 1 1 0-2H8v-4H3.75a1 1 0 0 1 0-2H8V3.75a1 1 0 0 1 1-1M10 10v4h4v-4z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHashStraight;